<template>
  <div>
    <Header title="Check In" subtitle="Check In Participants"/>
    <template v-if="!loading">
      <div :class="[$style.items, $style.items2]">
        <Card
            title="QR Code Check In"
            direction="column"
            color="background"
            background="black"
            spacing="tad"
            as="section"
        >
          <qrcode-stream @detect="onDetect"></qrcode-stream>
        </Card>
        <Card
            title="Last Scanned Data"
            direction="column"
            color="background"
            background="black"
            spacing="tad"
            as="section"
        >
          <div v-if="lastUser">
            <TextComponent as="p" color="background" type="paragraph">
              User ID: {{ lastUser._id }}
            </TextComponent>
            <TextComponent as="p" color="background" type="paragraph">
              User Type: {{ lastUserType }}
            </TextComponent>
            <TextComponent as="p" color="background" type="paragraph">
              First Name: {{ lastUser.firstName }}
            </TextComponent>
            <TextComponent as="p" color="background" type="paragraph">
              Last Name: {{ lastUser.lastName }}
            </TextComponent>
            <TextComponent as="p" color="background" type="paragraph">
              Email: {{ lastUser.email }}
            </TextComponent>
            <TextComponent as="p" color="background" type="paragraph">
              Shirt Size: {{ (lastUser.hackerApplication || {}).shirtSize || "No Data" }}
            </TextComponent>
            <TextComponent v-if="lastOutcome" as="p" color="background" type="paragraph">
              Last Outcome: Checked In
            </TextComponent>
            <TextComponent as="p" color="background" type="paragraph">
              Last Outcome: <strong style="color: red">NOT</strong> Checked In
            </TextComponent>
          </div>
          <div v-else>No data</div>
        </Card>
      </div>

    </template>
    <template v-else>
      Loading...
    </template>
  </div>
</template>

<script>
  import Button from '@hackthe6ix/vue-ui/Button';
  import Input from '@hackthe6ix/vue-ui/Input';
  import TextComponent from '@hackthe6ix/vue-ui/Text/index';
  import ComboBox from '@hackthe6ix/vue-ui/ComboBox';
  import swal from 'sweetalert';
  import Card from '../../../containers/Card';
  import Header from '../../../containers/Header';
  import Stack from "@hackthe6ix/vue-ui/Stack";
  import {QrcodeStream} from "vue-qrcode-reader";

  import 'vue-awesome/icons/link';
  import 'vue-awesome/icons/unlink';
  import {getObject} from "@/utils/api";

  import {processCheckInUser} from "@/utils/checkInShared";

  export default {
    name: 'CheckIn',
    components: {
      TextComponent,
      Header,
      Button,
      Card,
      Input,
      ComboBox,
      Stack,
      QrcodeStream
    },
    data() {
      return {
        loading: false,
        lastUser: undefined,
        lastUserType: "Unknown",
        lastOutcome: false
      }
    },
    methods: {

      onDetect(detectedCode) {
        detectedCode.then(async (value) => {
          // console.log(value);
          try {
            const hackerData = JSON.parse(value.content);
            let response;
            let lastUserType = "Unknown";

            if(hackerData.userType === "User") {
              response = await getObject('user', {
                filter: {
                  _id: hackerData.userID,
                },
              });
              lastUserType = "User";
            }
            else if(hackerData.userType === "ExternalUser") {
              response = await getObject('externaluser', {
                filter: {
                  _id: hackerData.userID,
                },
              });
              lastUserType = "ExternalUser";
            }

            if (response.success && response.data[0]) {
              if(response.data[0]?.status?.checkedIn) {
                swal('Info', 'User is already checked in.', 'success');
                this.lastUser = response.data[0];
                this.lastUserType = lastUserType;

                this.lastOutcome = false;
              }
              else {
                processCheckInUser(response.data[0], hackerData.userType).then((checkedIn) => {
                  this.lastUser = response.data[0];
                  this.lastUserType = lastUserType;

                  this.lastOutcome = checkedIn;
                })
              }


            } else {
              swal('Error', 'Unable to get user', 'error');
            }
          }
          catch(e) {
            console.error("Detected invalid check in QR code");
          }
        });
      }
    },
    mounted() {
    }
  };
</script>

<style src="./CheckIn.module.scss" lang="scss" module/>
